export default function(selector) {
    const configElements = document.querySelectorAll(selector);
    let config = {};

    if (configElements) {
        try {
            // eslint-disable-next-line no-useless-escape
            var regex = /\,(?!\s*?[\{\[\"\'\w])/g;
            Array.prototype.forEach.call(configElements, function(el) {
                let input = el.innerHTML.trim(); // this is the initial string of data
                let correct = input.replace(regex, ""); // remove all trailing commas
                let data = JSON.parse(correct); // build a new JSON object based on correct string
                Object.assign(config, data);
            });
        } catch (e) {
            console.error(e); // eslint-disable-line no-console
        }
    }

    return config;
}
